import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito experiencia previa en alimentación saludable?',
    a: 'No. El sistema está diseñado para empezar desde cero. El protocolo te guía paso a paso sin asumir ningún conocimiento previo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con acceso a todo el kit en PDF y al microcurso. Acceso garantizado en menos de 5 minutos.'
  }, {
    q: '¿Funciona si tengo una condición diagnosticada?',
    a: 'El kit tiene contenido general adaptable a la mayoría de los casos. Si tenés una condición específica, el Reset Digestivo Avanzado (Bono 5) incluye protocolos más detallados.'
  }, {
    q: '¿Qué lo diferencia de los consejos que encuentro gratis en internet?',
    a: 'El problema no es la falta de información — es el exceso de información contradictoria sin sistema. REINICIO INTERNO no te da más datos sueltos: te da un protocolo con orden, progresión y herramientas concretas para que lo que sabés se convierta en cambio real.'
  }, {
    q: '¿En cuánto tiempo veo resultados?',
    a: <div className="mt-4 bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-49">
          <table className="w-full text-sm text-left" data-id="element-50">
            <thead className="bg-gray-50 text-gray-700 uppercase" data-id="element-51">
              <tr data-id="element-52">
                <th className="px-4 py-3 border-b" data-id="element-53">Días</th>
                <th className="px-4 py-3 border-b" data-id="element-54">Qué esperás</th>
              </tr>
            </thead>
            <tbody data-id="element-55">
              <tr className="border-b" data-id="element-56">
                <td className="px-4 py-3 font-medium" data-id="element-57">Días 1–3</td>
                <td className="px-4 py-3" data-id="element-58">Ajuste inicial</td>
              </tr>
              <tr className="border-b" data-id="element-59">
                <td className="px-4 py-3 font-medium" data-id="element-60">Días 4–7</td>
                <td className="px-4 py-3" data-id="element-61">Primera reducción de hinchazón</td>
              </tr>
              <tr className="border-b" data-id="element-62">
                <td className="px-4 py-3 font-medium" data-id="element-63">Días 8–11</td>
                <td className="px-4 py-3" data-id="element-64">
                  Cambio notable en digestión y energía
                </td>
              </tr>
              <tr data-id="element-65">
                <td className="px-4 py-3 font-medium" data-id="element-66">Días 12–14</td>
                <td className="px-4 py-3" data-id="element-67">Consolidación y energía renovada</td>
              </tr>
            </tbody>
          </table>
        </div>
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días, devolución del 100%, sin preguntas. Sin drama.'
  }];
  return <SectionWrapper className="bg-secondary" data-id="element-68">
      <div className="text-center mb-12" data-id="element-69">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-4" data-id="element-70">
          <HelpOutlineIcon data-id="element-71" />
        </div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-72">
          LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-73">
        {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-74">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-75">
              <span className="font-bold text-gray-900 pr-4" data-id="element-76">{faq.q}</span>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.3
          }} data-id="element-77">
                <ExpandMoreIcon className="text-primary" data-id="element-78" />
              </motion.div>
            </button>
            <AnimatePresence data-id="element-79">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-80">
                  <div className="px-6 pb-5 text-gray-600 border-t border-gray-50 pt-4" data-id="element-81">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </SectionWrapper>;
}